import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['division', 'divisionContainer', 'confirmDialog']

  connect() {
    this.isConfirmed = false
  }

  confirmSubmit(event) {
    if (this.isConfirmed) return

    event.preventDefault()
    if (this.hasConfirmDialogTarget) {
      this.confirmDialogTarget.showModal()
    }
  }

  approveSubmit() {
    this.isConfirmed = true

    if (this.hasConfirmDialogTarget) {
      this.confirmDialogTarget.close()
    }

    this.element.requestSubmit()
  }

  cancelSubmit() {
    if (this.hasConfirmDialogTarget) {
      this.confirmDialogTarget.close()
    }
  }

  companyChanged(e) {
    const companyId = e.target.value
    if (!companyId) return

    const path = '/outplacement/global/programs'
    const queryParams = new URLSearchParams({ company_id: companyId })
    const result = fetch(`${path}?${queryParams.toString()}`).then(
      (response) => {
        if (response.ok) {
          return response.json()
        } else {
          throw new Error('Network response was not ok')
        }
      },
    )
    result
      .then((data) => {
        const { global_contract_license_details: divisions } = data
        this.handleDivisionData(divisions)
        return null
      })
      .catch((error) => {
        console.error('Error fetching programs:', error)
      })
  }

  handleDivisionData(divisions) {
    this.divisionTarget.innerHTML = ''
    if (!divisions || divisions.length === 0) {
      const noOption = document.createElement('option')
      noOption.textContent = '-- No Divisions --'
      this.divisionTarget.appendChild(noOption)
      this.divisionContainerTarget.classList.add('hidden')
      return
    }
    const option = document.createElement('option')
    option.textContent = ' - Choose a Division - '
    this.divisionTarget.appendChild(option)
    this.divisionContainerTarget.classList.remove('hidden')
    divisions.forEach((division) => {
      const option = document.createElement('option')
      option.value = division.id
      option.textContent = division.name
      this.divisionTarget.appendChild(option)
    })
  }
}
